import React, { useState, useEffect, useMemo } from 'react';
import { useDebounce } from 'hooks/useDebouce';
import {
  SearchContainer,
  SearchIconContainer,
  SearchInput
} from '../../styles';

/** Componente de busca / filtragem dos agentes e das filas */
export const SearchComponent = ({
  isActive,
  searchValue,
  onToggle,
  onChange
}) => {
  const { withDebounce } = useDebounce();

  // Cria um estado para rastrear o valor de entrada localmente antes de aplicar o debounce
  const [localValue, setLocalValue] = useState(searchValue || '');

  // Atualiza o valor local quando a propriedade searchValue muda
  useEffect(() => {
    setLocalValue(searchValue || '');
  }, [searchValue]);

  // Lidar com as mudanças de entrada imediatamente no estado local
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    debouncedUpdateParent(newValue);
  };

  // Função debounced que funciona com o valor completo
  const debouncedUpdateParent = useMemo(
    () =>
      withDebounce((value) => {
        onChange({
          target: {
            value: value
          }
        });
      }, 300),
    [withDebounce, onChange]
  );

  return (
    <SearchContainer>
      <SearchIconContainer
        title={`Clique para filtrar os cards.`}
        onClick={onToggle}
      >
        <i className="fa fa-search" />
      </SearchIconContainer>
      <SearchInput
        isActive={isActive}
        type="text"
        placeholder="Filtrar..."
        value={localValue} // Usar o estado local para feedback imediato
        onChange={handleInputChange}
      />
    </SearchContainer>
  );
};
